// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDK3tM7gBWU2MHXHaXOF2svbr41sHqWWn8",
  authDomain: "biomarker-codes.firebaseapp.com",
  databaseURL: "https://biomarker-codes-default-rtdb.firebaseio.com",
  projectId: "biomarker-codes",
  storageBucket: "biomarker-codes.appspot.com",
  messagingSenderId: "641092687953",
  appId: "1:641092687953:web:ee2b8cbeef257d225cc070",
  measurementId: "G-BWHQ9JVT8Q"
}
export default firebaseConfig